import React from 'react';
import InlineSVG from 'react-inlinesvg';
import { useSelector } from 'react-redux';

import assets from '../../assets';
import { RootState } from '../../redux';
import CustomerGroupSpan from './customer-group-span';

function ConditionalCustomerGroup() {
  const context = useSelector((state: RootState) => state.api.context);

  if (
    !context ||
    !context.customer_group_uuid ||
    context.enforce === 'customer'
  ) {
    return null;
  }

  return (
    <>
      <InlineSVG src={assets.icons.arrowRight} />
      <InlineSVG src={assets.icons.group} />
      <CustomerGroupSpan />
    </>
  );
}

export default ConditionalCustomerGroup;
